import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import axios from 'axios';
import config from '../../../../../config';
import { isValidPhone } from '../../../../../common/validators';
import { toast } from 'react-toastify';

function ContactEditModal({ show, onHide, vendorId, contacts = [], onUpdated }) {
    const [contactList, setContactList] = useState(contacts);
    const [saving, setSaving] = useState(false);

    const handleContactChange = (index, field, value) => {
        const updated = [...contactList];
        updated[index][field] = value;
        setContactList(updated);
    };

    const addContact = () => {
        setContactList([...contactList, { name: '', number: '' }]);
    };

    const removeContact = (index) => {
        const updated = contactList.filter((_, i) => i !== index);
        setContactList(updated);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);

        try {
            await axios.put(`${config.API_BASE_URL}/vendors/${vendorId}`, {
                contact_persons: contactList
            });

            toast.success('Contacts updated successfully');
            onUpdated();
            onHide();
        } catch (error) {
            console.error('Failed to update contacts', error);
            toast.error('Failed to update contacts');
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Edit Contact Persons</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    {contactList.map((person, index) => (
                        <Row key={index} className="align-items-end mb-2">
                            <Col md={5} xl={4}>
                                <Form.Group>
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        value={person.name || ''}
                                        onChange={(e) => handleContactChange(index, 'name', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={10} md={6} xl={4}>
                                <Form.Group>
                                    <Form.Label>Number</Form.Label>
                                    <PhoneInput
                                        country="in"
                                        value={person.number || ''}
                                        onChange={(val) => handleContactChange(index, 'number', `+${val}`)}
                                        inputClass={
                                            person.number && !isValidPhone(person.number)
                                                ? 'is-invalid'
                                                : ''
                                        }
                                    />
                                    {person.number && !isValidPhone(person.number) && (
                                        <div className="invalid-feedback d-block">
                                            Invalid phone number
                                        </div>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col xs={2} md={1} className="ps-md-0">
                                {contactList.length > 1 && index > 0 && (
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        onClick={() => removeContact(index)}
                                    >
                                        ×
                                    </Button>
                                )}
                            </Col>
                            <hr className="mt-3 mb-0" />
                        </Row>
                    ))}

                    <Button variant="secondary" size="sm" onClick={addContact}>
                        + Add Contact Person
                    </Button>

                    <div className="mt-4">
                        <Button type="submit" variant="primary" disabled={saving}>
                            {saving ? 'Saving...' : 'Save'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default ContactEditModal;
